const mapping: Record<string, string> = {
  id: 'c=>c.Id',
  firstname: 'c=>c.Firstname',
  lastname: 'c=>c.Lastname',
  pesel: 'c=>c.Pesel',
  documentNumber: 'c=>c.DocumentNumber',
  company: 'c=>c.Company',
}

export const mapSortCustomerParams = (key: string) => mapping[key]
